import { LOGIN_FIRST_PAGE } from '@/router/consts';
import client from './http';

export default function initInterceptors() {
  function handleError(error) {
    if (!error.response) {
      // Network error, future toaster 🍞
      return Promise.reject(error);
    }

    const { status } = error.response;
    if (status === 403) {
    /*
     * We reload the page and not use Vue Router to redirect to the login page
     * to make sure that all other HTTP requests are cancelled and won't
     * cause additional redirects after we navigate
     */
      window.location.assign(LOGIN_FIRST_PAGE);
      return Promise.resolve();
    }
    return Promise.reject(error);
  }

  client.interceptors.response.use(
    response => response,
    handleError,
  );
}
